<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<egranty-section-divider
			icon="flag"
			text="Działania"
		/>
		<br style="margin-top: 10px">
		<div style="padding-left: 20px; padding-right: 20px;" class="agency-choose-action">


			<div v-if="!current.length && !readonly">
				<v-card>
					<v-card-text>
						<strong>
							Nie podano żadnych działań
						</strong>
					</v-card-text>
				</v-card>
				<egranty-validation-error
					:error="error"
				></egranty-validation-error>
			</div>
			<div
				v-for="(action,index) in current"
				:key="index"
			>
				<v-card>
					<v-toolbar :color="getStatusColor(action)" style="margin: 0" class="agency-choose-action-card">
						<v-toolbar-title>
							<v-layout row>
								<h3>Działanie nr {{action.serialNumber}} {{getStatus(action)}}</h3>
								&emsp;
								<egranty-icon-button
									v-if="!readonly"
									text="usuń Działanie"
									icon="delete"
									color="white"
									@click='removeAction(index)'
								/>
							</v-layout>
						</v-toolbar-title>
					</v-toolbar>
					<v-layout row>
						<v-flex xs6>
							<egranty-text-input-field
								v-if="!readonly"
								textarea
								:disabled="readonly"
								style="width: 1000px; padding: 10px"
								v-model="action.action"
								label='Nazwa'
								for="agency-choose-actions-name-action"
								id="agency-choose-actions-name-action"
								@blur="sync()"
							></egranty-text-input-field>
							<div v-if="readonly" style="padding: 10px">
								<strong>Nazwa</strong> <br>
								<div style="padding: 5px">
									{{action.action}}
								</div>
							</div>
						</v-flex>
						<v-flex xs6>
							<egranty-text-input-field
								v-if="!readonly"
								style="padding: 10px"
								:disabled="readonly"
								v-model="action.place"
								label="Miejsce"
								for="agency-choose-actions-place"
								id="agency-choose-actions-place"
								@input="sync"
							></egranty-text-input-field>
							<div v-if="readonly" style="padding: 10px">
								<strong>Miejsce</strong> <br>
								<div style="padding: 5px">
									{{action.place}}
								</div>
							</div>
						</v-flex>
					</v-layout>

					<egranty-validation-error
						v-for="error in action.errors"
						:key="error"
						:error=error
					></egranty-validation-error>
				</v-card>
			</div>
			<br>
			<offer-button
				v-if="!readonly"
				:text="current.length === 0 ? 'Dodaj działanie' : 'Dodaj kolejne działanie'"
				icon="add"
				@click="addAction"
			></offer-button>

		</div>
	</div>
</template>

<script>
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import OfferButton from "./../../offer/components/OfferButton";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";

	export default {
		name: "AgencyChooseActions",
		components: {
			EgrantyIconButton,
			EgrantySectionDivider,
			EgrantyValidationError,
			OfferButton, EgrantyTextInputField
		},
		data () {
			return {
				error: "",
				current: [],
				datesOpen: [],
			};
		},

		watch: {
			value: {
				immediate: true,
				handler (val, oldVal) {
					if (val === undefined) {
						val = [];
					}
					if (oldVal === undefined) {
						val.sort((a, b) => a.serialNumber - b.serialNumber);
					}
					this.current = val;
				},
			},
		},

		methods: {

			getStatusColor (action) {
				if (this.getStatus(action) === '(Usunięte)') {
					return "red lighten-2";
				}
				if (this.getStatus(action) === '(Nowe)') {
					return "green lighten-2";
				}
				if (this.getStatus(action) === '(Zmienione)') {
					return "blue lighten-2";
				}
				return "grey lighten";
			},

			getStatus (originalAction) {
				let action = JSON.parse(JSON.stringify(originalAction));
				if (this.oldVersion) {
					let found = this.oldVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Nowe)";
					} else {
						found = JSON.parse(JSON.stringify(found));
						let currentId = action.id;
						let foundId = found.id;
						action.id = 0;
						found.id = 0;
						let identical = JSON.stringify(action) !== JSON.stringify(found);
						action.id = currentId;
						found.id = foundId;
						if (identical) {
							return "(Zmienione)";
						}
					}
				}
				if (this.newVersion) {
					let found = this.newVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Usunięte)";
					} else {
						found = JSON.parse(JSON.stringify(found));
						let currentId = action.id;
						let foundId = found.id;
						action.id = 0;
						found.id = 0;
						let identical = JSON.stringify(action) !== JSON.stringify(found);
						action.id = currentId;
						found.id = foundId;
						if (identical) {
							return "(Zmienione)";
						}
					}
				}

				return "";
			},

			validate () {
				let valid = true;
				if (this.current.length === 0) {
					valid &= false;
					this.error = "Proszę dodać co najmniej jedno działanie";
				}
				for (let action of this.current) {
					valid &= this.validateAction(action);
				}
				if (valid) { //valid tutaj jest 1 lub 0, jak zwracamy przez return valid to uznaje to jako błąd
					return true;
				}
				return false;

			},

			validateAction (action) {
				this.$set(action, 'errors', []);
				if (action.action === '') {
					action.errors.push("Proszę uzupełnić nazwę działania");
				}
				if (action.place === '') {
					action.errors.push("Proszę uzupełnić miejsce działania");
				}
				return action.errors.length === 0;
			},

			startEdit (action) {
				if (this.readonly) {
					return;
				}
				this.$set(action, "nameEdited", true);
			},

			endEdit (action) {
				this.$set(action, "nameEdited", false);
			},

			sync () {
				for (var action of this.current) {
					this.$set(action, 'errors', []);
				}
				this.$emit("input", this.current);
			},

			removeAction (index) {
				this.current.splice(index, 1);
				this.reassignSerialNumbers();
				this.sync();
			},

			addRealizationDate (index) {
				this.current[index].realizationDates.push(
					{
						start: "",
						end: "",
					},
				);
			},

			addAction () {
				this.current.push(
					{
						place: "",
						action: "",
						nameEdited: false,
						beneficiariesData: {},
						realizationDates: [],
						id: this.getFreeId(),
						serialNumber: null,
						idFake: true,
					});
				this.reassignSerialNumbers();
				this.sync();
			},


			reassignSerialNumbers () {
        if (this.readonly) return;

				for (let action of this.current) {
					if (!this.isSerialNumberPermanentlyTaken(action.serialNumber)) {
						action.serialNumber = null;
					}
				}

				for (let action of this.current) {
					if (!this.isSerialNumberPermanentlyTaken(action.serialNumber)) {
						action.serialNumber = this.getSerialNumber();
					}
				}
				this.current = this.current.sort((a, b) => a.serialNumber - b.serialNumber);
			},

			isSerialNumberPermanentlyTaken (serialNumber) {
				for (let actionSerialNumber of this.takenSerialNumbers) {
					if (actionSerialNumber === serialNumber) {
						return true;
					}
				}
				return false;
			},

			getSerialNumber () {
				let freeNumber = 0;
				let failed;
				do {
					failed = false;
					freeNumber++;
					for (let action of this.current) {
						if (action.serialNumber === freeNumber) {
							failed = true;
						}
					}
					for (let actionSerialNumber of this.takenSerialNumbers) {
						if (actionSerialNumber === freeNumber) {
							failed = true;
						}
					}
				} while (failed);
				return freeNumber;
			},

			getFreeId () {
				let firstFree = 0;
				for (let action of this.current) {
					firstFree = Math.max(1 + action.id, firstFree);
				}
				return firstFree;
			},
		},

		props: {
			oldVersion: {},
			readonly: {default: false},
			value: {},
			takenSerialNumbers: {},
			minStart: String,
			maxEnd: String
		},
	};
</script>

<style scoped>

	.grey {
		background-color: #0052A5 !important;
	}

</style>
